// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"WD-z","smallCardRow":"XD-z","largeCardRow":"YD-z","productSearchRow":"ZD-z","curatedRow":"_D-z"};